import React, { useState, useEffect } from "react";
import "../../../components/Styles/FormStyle.css";
import "../../../components/Styles/SecondPage.css";
import { secret } from "../data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CompanyDetails from "./companyDetails";
import Choosen from "./Choosen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  iconColor: "green",
  showConfirmButton: false,
  timer: 1000,
  timerProgressBar: true,
});

const MySwal = withReactContent(Swal2);

const ThirdPage = (props) => {
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState("");
  const [companyOffer, setCompanyOffer] = useState("");
  const [analysisProgress, setAnalysisProgress] = useState(0);
  const [analysisProgressLabel, setAnalysisProgressLabel] = useState(
    "wprowadzam dane do algorytmu"
  );
  const [analysisCounter, setAnalysisCounter] = useState(0);
  const [companyOfferOption, setCompanyOfferOption] = useState([]);
  const [sortOption, setSortOption] = useState("experience");
  const [showDetails, setShowDetails] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const [choosen, setChoosen] = useState("");
  const [choosenB, setChoosenB] = useState(false);
  const [sendAss, setSendAss] = useState(false);

  const checkIncludes = (arr, value) => {
    var bool = false;

    arr.map((el) => {
      if (JSON.stringify(el).includes(value)) {
        bool = true;
      }
    });

    return bool;
  };

  const checkIncludesOffer = (arr, value, value2, companyId) => {
    var bool = false;

    arr.map((el) => {
      if (
        +el.companyId === +companyId &&
        +el.entranceeCost === +value &&
        +el.successFee === +value2
      ) {
        bool = true;
      }
    });

    return bool;
  };

  const makeid = (length) => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };

  const fetchCompanies = async () => {
    var body = {};
    await fetch("https://api.twojeskd.pl/get_companyData_full", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secret,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data.map((el) => {
          if (checkIncludes(arr, el.companyId) === false) {
            arr.push(el.companyId);
          }
        });

        var arr2 = [];

        arr.map((el) => {
          var obj = {
            id: el,
            name: data.filter(
              (ex) => ex.descType === "title" && +ex.companyId === +el
            )[0].descText,
            marketYear: data.filter(
              (ex) => ex.descType === "marketYear" && +ex.companyId === +el
            )[0].descText,
            caseCount: data.filter(
              (ex) => ex.descType === "caseCount" && +ex.companyId === +el
            )[0].descText,
            winCases: data.filter(
              (ex) => ex.descType === "winCases" && +ex.companyId === +el
            )[0].descText,
            winRealCases: data.filter(
              (ex) => ex.descType === "winRealCases" && +ex.companyId === +el
            )[0].descText,
            howLong:
              new Date().getFullYear() -
              data.filter(
                (ex) => ex.descType === "marketYear" && +ex.companyId === +el
              )[0].descText,
            logo: data.filter((ex) => +ex.companyId === +el)[0].logo,
            image: data.filter((ex) => +ex.companyId === +el)[0].image,
            description: data.filter(
              (ex) => ex.descType === "description" && +ex.companyId === +el
            )[0].descText,
          };
          arr2.push(obj);
        });

        setCompanyData(arr2);
        fetchOffer(arr2);
      })
      .catch((error) => {});
  };

  const sortArr = (e, companyDataTemp) => {
    try {
      var arr = companyData;

      if (companyDataTemp) {
        arr = companyDataTemp;
      }

      if (
        e !== undefined
          ? e.target.value === "experience"
          : sortOption === "experience"
      ) {
        arr = arr.sort((a, b) => b.howLong - a.howLong);
      }

      if (
        e !== undefined
          ? e.target.value === "winning"
          : sortOption === "winning"
      ) {
        arr = arr.sort((a, b) => b.winCases - a.winCases);
      }

      if (
        e !== undefined
          ? e.target.value === "offerow"
          : sortOption === "offerow"
      ) {
        arr = arr.sort((a, b) => a.lowow - b.lowow);
        var op = [];
        arr.map((el) => {
          var obj = {
            companyId: el.id,
            id: el.lowowid,
          };
          op.push(obj);
        });

        setCompanyOfferOption(op);
      }

      if (
        e !== undefined ? e.target.value === "offer" : sortOption === "offer"
      ) {
        arr = arr.sort((a, b) => a.lowcost - b.lowcost);
        var op = [];
        arr.map((el) => {
          var obj = {
            companyId: el.id,
            id: el.lowcostid,
          };
          op.push(obj);
        });

        setCompanyOfferOption(op);
      }

      setCompanyData(arr);
      if (e !== undefined) {
        setSortOption(e.target.value);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchOffer = async (companyDataTemp) => {
    var body = {};
    await fetch("https://api.twojeskd.pl/get_companyOffer_full", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secret,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        try {
          var arr = [];
          data.map((el) => {
            if (
              !checkIncludesOffer(
                arr,
                el.entranceeCost,
                el.successFee,
                el.companyId
              )
            ) {
              arr.push(el);
            }
          });
          var oArr = arr.sort((a, b) => a.entranceeCost - b.entranceeCost);

          setCompanyOffer(oArr);
          var arr2 = [];
          oArr.map((el) => {
            if (
              arr2.filter((ep) => +ep.companyId === +el.companyId).length === 0
            ) {
              arr2.push({ companyId: el.companyId, id: el.id });
            }
          });
          setCompanyOfferOption(arr2);

          var arr4 = [];
          oArr.map((el) => {
            var obj = {
              companyId: el.companyId,
              offerId: el.id,
              offerSum:
                +el.entranceeCost +
                (el.successFeeType === "PLN"
                  ? +el.successFee
                  : (+el.successFee / 100) *
                    (el.type === "benefitValue"
                      ? props.total_benefit > 0
                        ? props.total_benefit
                        : props.userCreditData.creditAmmount * 0.8
                      : props.userCreditData.creditAmmount)),
            };
            arr4.push(obj);
          });

          console.log(oArr);

          var arr3 = [];
          companyDataTemp.map((el) => {
            console.log(el);
            var obj = {
              id: el.id,
              name: el.name,
              marketYear: el.marketYear,
              caseCount: el.caseCount,
              winCases: el.winCases,
              winRealCases: el.winRealCases,
              howLong: el.howLong,
              lowow: oArr.filter((o) => +o.companyId === +el.id)[0]
                .entranceeCost,
              lowowid: oArr.filter((o) => +o.companyId === +el.id)[0].id,
              logo: el.logo,
              image: el.image,
              description: el.description,
            };
            arr3.push(obj);
          });

          var arr5 = [];
          arr3.map((el) => {
            var obj = {
              id: el.id,
              name: el.name,
              marketYear: el.marketYear,
              caseCount: el.caseCount,
              winCases: el.winCases,
              winRealCases: el.winRealCases,
              howLong: el.howLong,
              lowow: el.lowow,
              lowowid: el.lowowid,
              lowcost: arr4
                .sort((a, b) => a.offerSum - b.offerSum)
                .filter((o) => +o.companyId === +el.id)[0].offerSum,
              lowcostid: arr4
                .sort((a, b) => a.offerSum - b.offerSum)
                .filter((o) => +o.companyId === +el.id)[0].offerId,
              logo: el.logo,
              image: el.image,
              description: el.description,
            };
            arr5.push(obj);
          });

          sortArr(undefined, arr5);
          setCompanyData(arr5);
          setLoading(false);
        } catch (err) {
          console.log(err);
        }
      })
      .catch((error) => {});
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const increment = () => {
    var value = 0;
    var viewpopup = false;
    clearInterval(interval);
    var interval = setInterval(() => {
      var p = 1 / 60;

      if (value * p <= 100 && !props.analysisReady) {
        value++;
        setAnalysisCounter(value);
        setAnalysisProgress(
          (value * p * 100).toFixed(0) > 100
            ? 100
            : (value * p * 100).toFixed(0)
        );
        var progress =
          (value * p * 100).toFixed(0) > 100
            ? 100
            : (value * p * 100).toFixed(0);
        if (progress > 15 && progress <= 30) {
          setAnalysisProgressLabel(
            "przygotowuje symulację spłaty zobowiązania"
          );
        }
        if (progress > 30 && progress <= 60) {
          setAnalysisProgressLabel("szacuje nadpłaty rat zobowiązania");
        }
        if (progress > 60 && progress <= 90) {
          setAnalysisProgressLabel("obliczam wartość korzyści");
        }
        if (progress > 90 && progress <= 100) {
          setAnalysisProgressLabel("szacuje wartość potencjalnych odsetek");
        }
      }
    }, 1000);
  };

  const getData = () => {
    fetchCompanies();
  };

  useEffect(() => {
    if (props.total_benefit > 0) {
      getData();
    }
  }, [props.total_benefit]);

  useEffect(() => {
    getData();
    increment();
  }, []);

  const getSfLabel = (companyId) => {
    var sfType = companyOffer.filter(
      (eo) =>
        +eo.id ===
        +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0].id
    )[0].successFeeType;
    var sf = companyOffer.filter(
      (eo) =>
        +eo.id ===
        +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0].id
    )[0].successFee;
    var type =
      companyOffer.filter(
        (eo) =>
          +eo.id ===
          +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0]
            .id
      )[0].type === "benefitValue"
        ? "od kwoty korzyści"
        : "od kwoty kredytu";

    return `${sfType === "PLN" ? numberWithCommas(sf) : sf}${
      sfType === "PLN" ? " PLN" : "%"
    } - ${type}`;
  };

  const getOwLabel = (companyId) => {
    var ow = companyOffer.filter(
      (eo) =>
        +eo.id ===
        +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0].id
    )[0].entranceeCost;

    return `${numberWithCommas(ow)} PLN`;
  };

  const getOptionsLabel = (companyId) => {
    var options =
      companyOffer.filter(
        (eo) =>
          +eo.id ===
          +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0]
            .id
      )[0].options === ""
        ? []
        : companyOffer
            .filter(
              (eo) =>
                +eo.id ===
                +companyOfferOption.filter(
                  (eo2) => +eo2.companyId === +companyId
                )[0].id
            )[0]
            .options.split(",");

    return options;
  };

  const getOfferCalc = (companyId) => {
    var sfType = companyOffer.filter(
      (eo) =>
        +eo.id ===
        +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0].id
    )[0].successFeeType;
    var sf =
      companyOffer.filter(
        (eo) =>
          +eo.id ===
          +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0]
            .id
      )[0].successFee + (sfType === "PLN" ? " PLN" : "%");
    var sfMath = companyOffer.filter(
      (eo) =>
        +eo.id ===
        +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0].id
    )[0].successFee;
    var type =
      companyOffer.filter(
        (eo) =>
          +eo.id ===
          +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0]
            .id
      )[0].type === "benefitValue"
        ? "od kwoty korzyści"
        : "od kwoty kredytu";

    var ow = numberWithCommas(
      companyOffer.filter(
        (eo) =>
          +eo.id ===
          +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0]
            .id
      )[0].entranceeCost + " PLN"
    );
    var owMath = companyOffer.filter(
      (eo) =>
        +eo.id ===
        +companyOfferOption.filter((eo2) => +eo2.companyId === +companyId)[0].id
    )[0].entranceeCost;

    var floor = "";
    var floorMath = 0;
    if (type === "od kwoty korzyści") {
      floor =
        "szacunkowa kwota korzyści - " +
        (props.total_benefit > 0
          ? numberWithCommas(props.total_benefit.toFixed(0))
          : numberWithCommas(
              (+props.userCreditData.creditAmmount * 0.8).toFixed(0)
            )) +
        " PLN";
      floorMath =
        props.total_benefit > 0
          ? +props.total_benefit.toFixed(0)
          : (props.userCreditData.creditAmmount * 0.8).toFixed(0);
    } else {
      floor =
        "wartość kredytu - " +
        numberWithCommas((props.userCreditData.creditAmmount * 1).toFixed(0)) +
        " PLN";
      floorMath = (props.userCreditData.creditAmmount * 1).toFixed(0);
    }

    return {
      floor: floor,
      ow: ow,
      owMath: owMath,
      floorMath: floorMath,
      sf: sf,
      sfType: sfType,
      sfMath: sfMath,
    };
  };

  const closeDetail = () => {
    setShowDetails(false);
  };

  const addChoosen = async (e) => {
    var arr = choosen.split(",").filter((eq) => eq !== "");
    if (arr.length + 1 <= 5) {
      arr.push(e.target.value);
      var str = "";
      arr.map((el) => {
        str = str + el + ",";
      });
      setChoosen(str);
      setChoosenB(true);
      await Toast.fire({
        icon: "success",
        title: "Dodano do kontaktu",
        backdrop: false,
      });
    } else {
      await Toast.fire({
        icon: "error",
        iconColor: "red",
        title: "Osiągnięto limit 5 kancelarii",
        backdrop: false,
      });
    }
  };

  const deleteChoosen = async (e) => {
    var arr = [];
    choosen
      .split(",")
      .filter((eq) => eq !== "")
      .map((el) => {
        if (+e.target.value !== +el) {
          arr.push(el);
        }
      });
    if (arr.length === 0) {
      setChoosen("");
      setChoosenB(false);
      await Toast.fire({
        icon: "warning",
        iconColor: "red",
        title: "Usunięto z kontaktu",
        backdrop: false,
      });
    } else {
      var str = "";
      arr.map((el) => {
        str = str + el + ",";
      });
      setChoosen(str);
      await Toast.fire({
        icon: "warning",
        iconColor: "red",
        title: "Usunięto z kontaktu",
        backdrop: false,
      });
    }
  };

  const sendAssingments = async () => {
    var body = {
      leadId: props.leadId,
      assingments: choosen.split(",").filter((el) => el !== ""),
    };
    await fetch("https://api.twojeskd.pl/insert_lead_assingments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secret,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        setSendAss(true);
      })
      .catch((error) => {});
  };

  const destkop = (
    <>
      <div className="mainContainerSecond">
        <div
          className="progressBox"
          style={{
            width: "25vw",
            border: "1px solid #949d97",
            borderBottomRightRadius: "5px",
            borderTopRightRadius: "5px",
            padding: "15px 15px",
            backgroundColor: "white",
            position: "fixed",
            left: "0",
            zIndex: "2",
            bottom: "0",
            boxShadow: "-2px -2px 29px 0px rgba(66, 68, 90, 1)",
            paddingLeft: "15px",
          }}
        >
          {analysisProgress === 100 || props.analysisReady ? (
            <>
              <p
                style={{
                  textTransform: "lowercase",
                  fontSize: "1vw",
                  margin: "0",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                Przeanalizowaliśmy roszczenie wynikające z spłaty Twojego
                zobowiązania{" "}
                <span style={{ textTransform: "uppercase" }}>
                  {props.userCreditData.creditCurrency === "PLN"
                    ? "CHF"
                    : props.userCreditData.creditCurrency}
                </span>
              </p>
              <a
                className="submitButtonFirstPage"
                style={{
                  marginTop: "10px",
                  fontSize: ".9vw",
                  padding: "5px",
                  color: "white",
                  height: "auto",
                  backgroundColor: "#949d97",
                  textDecoration: "none",
                  display: "block",
                  textAlign: "center",
                  width: "100%",
                  boxSizing: "border-box",
                }}
                href={props.analysis_link}
                target="_blank"
              >
                <FontAwesomeIcon
                  style={{ margin: "0", marginRight: "15px" }}
                  icon={faDownload}
                />
                pokaż wynik analizy roszczeń
              </a>
            </>
          ) : (
            <>
              <p
                style={{
                  textTransform: "lowercase",
                  fontSize: ".8vw",
                  margin: "0",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                Generujemy analizę potencjalnego roszczenia z tytułu spłaty
                zobowiązania{" "}
                <span style={{ textTransform: "uppercase" }}>
                  {props.userCreditData.creditCurrency === "PLN"
                    ? "CHF"
                    : props.userCreditData.creditCurrency}
                </span>
              </p>
              <p
                style={{
                  textAlign: "center",
                  fontStyle: "italic",
                  margin: "10px 0px",
                  fontSize: ".9vw",
                }}
              >
                <span style={{ fontWeight: "600" }}>
                  {analysisProgressLabel}
                </span>
              </p>
              <div
                style={{
                  display: "flex",
                  height: "10px",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    border: "1px solid black",
                    borderRadius: "5px",
                    width: "25vw",
                    boxSizing: "border-box",
                    height: "15px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      height: "15px",
                      backgroundColor: "#949d97",
                      width: (20 / 100) * analysisProgress + "vw",
                      boxSizing: "border-box",
                    }}
                  ></div>
                </div>

                <p style={{ margin: "0", fontWeight: "0", fontSize: ".8vw" }}>
                  {analysisProgress}%
                </p>
              </div>{" "}
            </>
          )}
        </div>
        {showDetails ? (
          <CompanyDetails
            close={closeDetail}
            companyId={companyId}
            image={companyData.filter((el) => +el.id === +companyId)[0].image}
            description={
              companyData.filter((el) => +el.id === +companyId)[0].description
            }
            logo={companyData.filter((el) => +el.id === +companyId)[0].logo}
          />
        ) : (
          ""
        )}
        {choosen.length > 0 && !sendAss ? (
          <Choosen
            choosen={choosen}
            companyData={companyData}
            deleteChoosen={deleteChoosen}
            sendAssingments={sendAssingments}
          />
        ) : (
          ""
        )}
        <div
          className="contentSecond"
          style={{ display: "block", paddingTop: "25px" }}
        >
          {loading ? (
            <p>Ładuje oferty kancelarii prawnych...</p>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "center",
                }}
              >
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: ".7vw",
                    padding: "5px",
                    color: "white",
                    height: "auto",
                    backgroundColor:
                      sortOption === "experience" ? "orange" : "#949d97",
                    borderBottomLeftRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                  value={"experience"}
                  onClick={sortArr}
                >
                  ranking kancelarii wegdług doswiadczenia
                </button>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: ".7vw",
                    padding: "5px",
                    color: "white",
                    height: "auto",
                    backgroundColor:
                      sortOption === "winning" ? "orange" : "#949d97",
                    borderBottomLeftRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                  value={"winning"}
                  onClick={sortArr}
                >
                  ranking kancelarii wegdług ilości wygranych spraw
                </button>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: ".7vw",
                    padding: "5px",
                    color: "white",
                    height: "auto",
                    backgroundColor:
                      sortOption === "offer" ? "orange" : "#949d97",
                    borderBottomLeftRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                  value={"offer"}
                  onClick={sortArr}
                >
                  ranking kancelarii wegdług wartości całej usługi
                </button>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: ".7vw",
                    padding: "5px",
                    color: "white",
                    height: "auto",
                    backgroundColor:
                      sortOption === "offerow" ? "orange" : "#949d97",
                    borderBottomLeftRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                  value={"offerow"}
                  onClick={sortArr}
                >
                  ranking kancelarii wegdług wartości opłaty wstępnej
                </button>
              </div>
              <div
                style={{
                  marginTop: "0px",
                  border: "2px solid #949d97",
                  padding: "20px 20px",
                  borderBottomLeftRadius: "5px",
                  borderBottomRightRadius: "5px",
                }}
              >
                {companyData.map((el, index) => (
                  <>
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "5%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "5vw",
                          color: "lightgray",
                          fontFamily: "Arial",
                          fontWeight: "900",
                        }}
                      >
                        <p>{index + 1}</p>
                      </div>
                      <div
                        key={el.id}
                        style={{
                          border: "1px solid #949d97",
                          borderRadius: "5px",
                          marginBottom: "10px",
                          padding: "10px",
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          width: "95%",
                        }}
                      >
                        <div style={{ width: "10%", padding: "10px" }}>
                          <img
                            style={{
                              width: "100%",
                            }}
                            src={el.logo}
                          />
                        </div>
                        <div style={{ width: "75%", marginRight: "10px" }}>
                          <p
                            style={{
                              textTransform: "uppercase",
                              fontWeight: "600",
                              color: "gray",
                            }}
                          >
                            {el.name
                              .replaceAll("<BR>", "")
                              .replaceAll("<br>", "")}
                          </p>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              fontSize: ".8vw",
                              textAlign: "center",
                            }}
                          >
                            <div
                              style={{
                                border: "1px solid #949d97",
                                padding: "5px",
                                borderRadius: "5px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: "#949d97",
                                textTransform: "uppercase",
                              }}
                            >
                              Ilosc wygranych{" "}
                              <p
                                style={{
                                  textAlign: "center",
                                  margin: "0",
                                  marginTop: "5px",
                                }}
                              >
                                {el.winCases ? el.winCases : "brak danych"}
                              </p>
                            </div>
                            <div
                              style={{
                                border: "1px solid #949d97",
                                padding: "5px",
                                borderRadius: "5px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: "#949d97",
                                textTransform: "uppercase",
                              }}
                            >
                              Ilosc prowadzonych spraw
                              <p
                                style={{
                                  textAlign: "center",
                                  margin: "0",
                                  marginTop: "5px",
                                }}
                              >
                                {el.caseCount ? el.caseCount : "brak danych"}
                              </p>
                            </div>
                            <div
                              style={{
                                border: "1px solid #949d97",
                                padding: "5px",
                                borderRadius: "5px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: "#949d97",
                                textTransform: "uppercase",
                              }}
                            >
                              Ile lat na rynku
                              <p
                                style={{
                                  textAlign: "center",
                                  margin: "0",
                                  marginTop: "5px",
                                }}
                              >
                                {el.marketYear
                                  ? new Date().getFullYear() - el.marketYear
                                  : "brak danych"}
                              </p>
                            </div>
                            <div
                              style={{
                                border: "1px solid #949d97",
                                padding: "5px",
                                borderRadius: "5px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: "#949d97",
                                textTransform: "uppercase",
                              }}
                            >
                              Oferta
                              <select
                                style={{
                                  height: "auto",
                                  borderRadius: "5px",
                                  marginTop: "5px",
                                  width: "20vw",
                                  fontSize: ".8vw",
                                }}
                                value={
                                  companyOfferOption.filter(
                                    (cop) => +cop.companyId === +el.id
                                  )[0].id
                                }
                                onChange={(e) => {
                                  var arr = [];
                                  companyOfferOption.map((eq) => {
                                    if (+eq.companyId === +el.id) {
                                      arr.push({
                                        companyId: +el.id,
                                        id: +e.target.value,
                                      });
                                    } else {
                                      arr.push(eq);
                                    }
                                    setCompanyOfferOption(arr);
                                  });
                                }}
                              >
                                {companyOffer
                                  .filter((eq) => +eq.companyId === +el.id)
                                  .map((ep) => (
                                    <option key={ep.id} value={ep.id}>
                                      {ep.entranceeCost} PLN / {ep.successFee}
                                      {ep.successFeeType === "PLN"
                                        ? " " + ep.successFeeType
                                        : ep.successFeeType}{" "}
                                      -{" "}
                                      {ep.type === "benefitValue"
                                        ? "od kwoty korzyści"
                                        : "od kwoty kredytu"}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            width: "10%",
                            display: "block",
                          }}
                        >
                          <button
                            className="submitButtonFirstPage"
                            style={{
                              margin: "0",
                              fontSize: ".9vw",
                              color: "white",
                              height: "5vh",
                              backgroundColor: "#949d97",
                              border: "0px solid #949d97",
                              borderRadius: "10px",
                              minWidth: "8vw",
                              padding: "5px 10px",
                              fontWeight: "900",
                            }}
                            value={el.id}
                            onClick={(e) => {
                              setShowDetails(true);
                              setCompanyId(e.target.value);
                            }}
                          >
                            POKAż wizytówkę
                          </button>
                          {choosen
                            .split(",")
                            .filter((eq) => eq !== "")
                            .filter((ex) => +ex === +el.id).length === 0 ? (
                            !sendAss ? (
                              <button
                                className="submitButtonFirstPage"
                                style={{
                                  margin: "0",
                                  fontSize: ".9vw",
                                  color: "white",
                                  marginTop: "5px",
                                  height: "auto",
                                  backgroundColor: "orange",
                                  border: "0px solid #949d97",
                                  borderRadius: "10px",
                                  minWidth: "8vw",
                                  padding: "20px 10px",
                                  fontWeight: "900",
                                  animation: "pulseNew 2s infinite",
                                }}
                                value={el.id}
                                onClick={addChoosen}
                              >
                                Nawiąż kontakt
                              </button>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </div>
                        <div style={{ width: "100%" }}>
                          <p
                            style={{
                              fontWeight: "600",
                              textTransform: "uppercase",
                            }}
                          >
                            Kalkulacja ofertowa{" "}
                            <span
                              style={{
                                color: "lightgray",
                                textTransform: "lowercase",
                                fontWeight: "300",
                              }}
                            >
                              (wybierz ofertę z menu widocznego powyżej)
                            </span>
                          </p>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              fontSize: "1vw",
                            }}
                          >
                            <div style={{ width: "40%", padding: "5px 15px" }}>
                              <p style={{ margin: "0" }}>
                                Opłata wstępna:{" "}
                                <span style={{ fontWeight: "600" }}>
                                  {getOwLabel(el.id)}
                                </span>
                              </p>
                              <p style={{ margin: "0" }}>
                                Success fee:{" "}
                                <span style={{ fontWeight: "600" }}>
                                  {getSfLabel(el.id)}
                                </span>
                              </p>
                              <p style={{ margin: "0" }}>
                                Opcje dodatkowe:{" "}
                                <span style={{ fontWeight: "600" }}>
                                  {getOptionsLabel(el.id).length === 0 ? (
                                    "brak opcji dodatkowych"
                                  ) : (
                                    <ul
                                      style={{
                                        textTransform: "lowercase",
                                        margin: "0",
                                        paddingInlineStart: "20px",
                                      }}
                                    >
                                      {getOptionsLabel(el.id)
                                        .filter((op0) => op0 !== "")
                                        .map((op, index) => (
                                          <li key={index}>{op}</li>
                                        ))}
                                    </ul>
                                  )}
                                </span>
                              </p>
                            </div>
                            <div
                              style={{
                                width: "60%",
                                borderLeft: "2px solid #949d97",
                                padding: "5px 15px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0",
                                  textTransform: "uppercase",
                                  fontWeight: "600",
                                }}
                              >
                                Szacunkowa kalkulacja kosztu Twojej sprawy
                              </p>
                              <p
                                style={{
                                  margin: "0",
                                  textTransform: "lowercase",
                                  fontWeight: "300",
                                  color: "gray",
                                  fontSize: ".8vw",
                                }}
                              >
                                przedstawiona kalkulacja opiera się na
                                szacunkowej wycenie korzyści z prowadzonej
                                sprawy{" "}
                                <span
                                  style={{
                                    textTransform: "uppercase",
                                    paddingLeft: "2px",
                                    paddingRight: "2px",
                                  }}
                                >
                                  {props.userCreditData.creditCurrency === "PLN"
                                    ? "CHF"
                                    : props.userCreditData.creditCurrency}
                                </span>{" "}
                                oraz deklarowanej przez kancelarie ofercie
                              </p>
                              <div style={{ padding: "10px 0px" }}>
                                <p
                                  style={{
                                    fontSize: ".8vw",
                                    margin: "0",
                                    marginBottom: "5px",
                                  }}
                                >
                                  PODSTAWA WYLICZENIA WYNAGRODZENIA SUCCESS FEE:{" "}
                                  {getOfferCalc(el.id).floor}
                                </p>
                                <p
                                  style={{
                                    fontSize: ".8vw",
                                    margin: "0",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "gray",
                                      textTransform: "lowercase",
                                    }}
                                  >
                                    ten element wynagrodzenia zapłacisz po
                                    podpisaniu umowy, zwykle kancelarie oferują
                                    14-dniowy termin płatności
                                  </span>
                                  <br />
                                  OPŁATA WSTĘPNA: {getOfferCalc(el.id).ow}
                                </p>
                                <p
                                  style={{
                                    fontSize: ".8vw",
                                    margin: "0",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "gray",
                                      textTransform: "lowercase",
                                    }}
                                  >
                                    ten element wynagrodzenia zapłacisz po
                                    wygranej sprawie z części zwrotu
                                    napdpłaconych rat przez bank
                                  </span>
                                  <br />
                                  SUCCESS FEE: {getOfferCalc(el.id).sf}
                                  <br />
                                  WARTOŚĆ SUCCESS FEE: około{" "}
                                  {getOfferCalc(el.id).sf.includes("PLN")
                                    ? numberWithCommas(
                                        Math.round(getOfferCalc(el.id).sfMath)
                                      ) + " PLN"
                                    : numberWithCommas(
                                        Math.round(
                                          (getOfferCalc(el.id).sfMath / 100) *
                                            getOfferCalc(el.id).floorMath
                                        )
                                      ) + " PLN"}
                                </p>

                                <p
                                  style={{
                                    fontSize: ".8vw",
                                    margin: "0",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "gray",
                                      textTransform: "lowercase",
                                    }}
                                  >
                                    łącznie całość szacowanego wynagrodzenia
                                    kancelarii za poprowadzenie Twojej sprawy{" "}
                                    <span
                                      style={{ textTransform: "uppercase" }}
                                    >
                                      {props.userCreditData.creditCurrency ===
                                      "PLN"
                                        ? "CHF"
                                        : props.userCreditData.creditCurrency}
                                    </span>
                                  </span>
                                  <br />
                                  <span style={{ fontWeight: "600" }}>
                                    SZACOWANA KWOTA WYNAGRODZENIA: około{" "}
                                    {getOfferCalc(el.id).sf.includes("PLN")
                                      ? numberWithCommas(
                                          Math.round(
                                            getOfferCalc(el.id).sfMath +
                                              getOfferCalc(el.id).owMath
                                          )
                                        ) + " PLN"
                                      : numberWithCommas(
                                          Math.round(
                                            (getOfferCalc(el.id).sfMath / 100) *
                                              getOfferCalc(el.id).floorMath +
                                              getOfferCalc(el.id).owMath
                                          )
                                        ) + " PLN"}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );

  const mobile = (
    <>
      <div className="mainContainerSecond">
        <div
          className="progressBox"
          style={{
            width: "50vw",
            border: "1px solid rgba(0, 0, 0, 0.322)",
            borderBottomRightRadius: "5px",
            borderTopRightRadius: "5px",
            padding: "15px 15px",
            backgroundColor: "white",
            position: "fixed",
            left: "0",
            zIndex: "2",
            bottom: "0",
            boxShadow: "-2px -2px 29px 0px rgba(66, 68, 90, 1)",
            paddingLeft: "15px",
          }}
        >
          {analysisProgress === 100 || props.analysisReady ? (
            <>
              <p
                style={{
                  textTransform: "lowercase",
                  fontSize: "2vw",
                  margin: "0",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                Przeanalizowaliśmy roszczenie wynikające z spłaty Twojego
                zobowiązania{" "}
                <span style={{ textTransform: "uppercase" }}>
                  {props.userCreditData.creditCurrency === "PLN"
                    ? "CHF"
                    : props.userCreditData.creditCurrency}
                </span>
              </p>
              <button
                className="submitButtonFirstPage"
                style={{
                  marginTop: "10px",
                  fontSize: "2vw",
                  padding: "5px",
                  color: "white",
                  height: "auto",
                  backgroundColor: "#949d97",
                }}
                onClick={() => {
                  setShowDetails(true);
                }}
              >
                pokaż wynik analizy roszczeń
              </button>
            </>
          ) : (
            <>
              <p
                style={{
                  textTransform: "lowercase",
                  fontSize: "2vw",
                  margin: "0",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                Generujemy analizę potencjalnego roszczenia z tytułu spłaty
                zobowiązania{" "}
                <span style={{ textTransform: "uppercase" }}>
                  {props.userCreditData.creditCurrency === "PLN"
                    ? "CHF"
                    : props.userCreditData.creditCurrency}
                </span>
              </p>
              <p
                style={{
                  textAlign: "center",
                  fontStyle: "italic",
                  margin: "10px 0px",
                  fontSize: "2vw",
                }}
              >
                <span style={{ fontWeight: "600" }}>
                  {analysisProgressLabel}
                </span>
              </p>
              <div
                style={{
                  display: "flex",
                  height: "10px",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    border: "1px solid black",
                    borderRadius: "5px",
                    width: "45vw",
                    boxSizing: "border-box",
                    height: "15px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      height: "15px",
                      backgroundColor: "#74a4bcff",
                      width: (45 / 100) * analysisProgress + "vw",
                      boxSizing: "border-box",
                    }}
                  ></div>
                </div>

                <p style={{ margin: "0", fontWeight: "0", fontSize: "3vw" }}>
                  {analysisProgress}%
                </p>
              </div>{" "}
            </>
          )}
        </div>
        {showDetails ? (
          <CompanyDetails
            close={closeDetail}
            companyId={companyId}
            image={companyData.filter((el) => +el.id === +companyId)[0].image}
            description={
              companyData.filter((el) => +el.id === +companyId)[0].description
            }
            logo={companyData.filter((el) => +el.id === +companyId)[0].logo}
          />
        ) : (
          ""
        )}
        {choosen.length > 0 && !sendAss ? (
          <Choosen
            choosen={choosen}
            companyData={companyData}
            deleteChoosen={deleteChoosen}
            sendAssingments={sendAssingments}
          />
        ) : (
          ""
        )}
        <div
          className="contentSecond"
          style={{ display: "block", paddingTop: "25px" }}
        >
          {loading ? (
            <p>"Ładuje oferty kancelarii prawnych..."</p>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "center",
                }}
              >
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: "2vw",
                    padding: "5px",
                    color: "white",
                    height: "auto",
                    backgroundColor:
                      sortOption === "experience" ? "orange" : "#949d97",
                    borderBottomLeftRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                  value={"experience"}
                  onClick={sortArr}
                >
                  ranking kancelarii wegdług doswiadczenia
                </button>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: "2vw",
                    padding: "5px",
                    color: "white",
                    height: "auto",
                    backgroundColor:
                      sortOption === "winning" ? "orange" : "#949d97",
                    borderBottomLeftRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                  value={"winning"}
                  onClick={sortArr}
                >
                  ranking kancelarii wegdług ilości wygranych spraw
                </button>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: "2vw",
                    padding: "5px",
                    color: "white",
                    height: "auto",
                    backgroundColor:
                      sortOption === "offer" ? "orange" : "#949d97",
                    borderBottomLeftRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                  value={"offer"}
                  onClick={sortArr}
                >
                  ranking kancelarii wegdług wartości całej usługi
                </button>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    minWidth: "auto",
                    marginTop: "10px",
                    fontSize: "2vw",
                    padding: "5px",
                    color: "white",
                    height: "auto",
                    backgroundColor:
                      sortOption === "offerow" ? "orange" : "#949d97",
                    borderBottomLeftRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                  value={"offerow"}
                  onClick={sortArr}
                >
                  ranking kancelarii wegdług wartości opłaty wstępnej
                </button>
              </div>
              <div
                style={{
                  marginTop: "0px",
                  border: "2px solid #949d97",
                  padding: "20px 20px",
                  borderBottomLeftRadius: "5px",
                  borderBottomRightRadius: "5px",
                }}
              >
                {companyData.map((el, index) => (
                  <>
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "5%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "5vw",
                          color: "lightgray",
                          fontFamily: "Arial",
                          fontWeight: "900",
                        }}
                      >
                        <p>{index + 1}</p>
                      </div>
                      <div
                        key={el.id}
                        style={{
                          border: "1px solid #b6d6ccff",
                          borderRadius: "5px",
                          marginBottom: "10px",
                          padding: "10px",
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          width: "95%",
                        }}
                      >
                        <div style={{ width: "15%", padding: "10px" }}>
                          <img
                            style={{
                              width: "100%",
                            }}
                            src={el.logo}
                          />
                        </div>
                        <div style={{ width: "70%", marginRight: "10px" }}>
                          <p
                            style={{
                              textTransform: "uppercase",
                              fontWeight: "600",
                              color: "gray",
                            }}
                          >
                            {el.name
                              .replaceAll("<BR>", "")
                              .replaceAll("<br>", "")}
                          </p>
                        </div>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                              fontSize: "3vw",
                              textAlign: "center",
                            }}
                          >
                            <div
                              style={{
                                border: "1px solid #949d97",
                                padding: "5px",
                                borderRadius: "5px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: "#949d97",
                                textTransform: "uppercase",
                                width: "100%",
                                fontSize: "3vw",
                              }}
                            >
                              Ilosc wygranych{" "}
                              <p
                                style={{
                                  textAlign: "center",
                                  margin: "0",
                                  marginTop: "5px",
                                }}
                              >
                                {el.winCases ? el.winCases : "brak danych"}
                              </p>
                            </div>
                            <div
                              style={{
                                border: "1px solid #949d97",
                                padding: "5px",
                                borderRadius: "5px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: "#949d97",
                                textTransform: "uppercase",
                                width: "100%",
                                fontSize: "3vw",
                              }}
                            >
                              Ilosc prowadzonych spraw
                              <p
                                style={{
                                  textAlign: "center",
                                  margin: "0",
                                  marginTop: "5px",
                                }}
                              >
                                {el.caseCount ? el.caseCount : "brak danych"}
                              </p>
                            </div>
                            <div
                              style={{
                                border: "1px solid #949d97",
                                padding: "5px",
                                borderRadius: "5px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: "#949d97",
                                textTransform: "uppercase",
                                width: "100%",
                                fontSize: "3vw",
                              }}
                            >
                              Ile lat na rynku
                              <p
                                style={{
                                  textAlign: "center",
                                  margin: "0",
                                  marginTop: "5px",
                                }}
                              >
                                {el.marketYear
                                  ? new Date().getFullYear() - el.marketYear
                                  : "brak danych"}
                              </p>
                            </div>
                            <div
                              style={{
                                border: "1px solid #949d97",
                                padding: "5px",
                                borderRadius: "5px",
                                fontWeight: "600",
                                color: "white",
                                backgroundColor: "#949d97",
                                textTransform: "uppercase",
                                width: "100%",
                                fontSize: "3vw",
                              }}
                            >
                              Oferta
                              <select
                                style={{
                                  height: "auto",
                                  borderRadius: "5px",
                                  marginTop: "5px",

                                  width: "100%",
                                  fontSize: "3vw",
                                }}
                                value={
                                  companyOfferOption.filter(
                                    (cop) => +cop.companyId === +el.id
                                  )[0].id
                                }
                                onChange={(e) => {
                                  var arr = [];
                                  companyOfferOption.map((eq) => {
                                    if (+eq.companyId === +el.id) {
                                      arr.push({
                                        companyId: +el.id,
                                        id: +e.target.value,
                                      });
                                    } else {
                                      arr.push(eq);
                                    }
                                    setCompanyOfferOption(arr);
                                  });
                                }}
                              >
                                {companyOffer
                                  .filter((eq) => +eq.companyId === +el.id)
                                  .map((ep) => (
                                    <option key={ep.id} value={ep.id}>
                                      {ep.entranceeCost} PLN / {ep.successFee}
                                      {ep.successFeeType === "PLN"
                                        ? " " + ep.successFeeType
                                        : ep.successFeeType}{" "}
                                      -{" "}
                                      {ep.type === "benefitValue"
                                        ? "od kwoty korzyści"
                                        : "od kwoty kredytu"}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div style={{ width: "100%" }}>
                          <p
                            style={{
                              fontWeight: "600",
                              textTransform: "uppercase",
                              fontSize: "3vw",
                            }}
                          >
                            Kalkulacja ofertowa
                            <span
                              style={{
                                color: "lightgray",
                                textTransform: "lowercase",
                                fontWeight: "300",
                              }}
                            >
                              (wybierz ofertę z menu widocznego powyżej)
                            </span>
                          </p>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                              fontSize: "2vw",
                            }}
                          >
                            <div style={{ width: "100%", padding: "5px 5px" }}>
                              <p style={{ margin: "0" }}>
                                Opłata wstępna:{" "}
                                <span style={{ fontWeight: "600" }}>
                                  {getOwLabel(el.id)}
                                </span>
                              </p>
                              <p style={{ margin: "0" }}>
                                Success fee:{" "}
                                <span style={{ fontWeight: "600" }}>
                                  {getSfLabel(el.id)}
                                </span>
                              </p>
                              <p style={{ margin: "0" }}>
                                Opcje dodatkowe:{" "}
                                <span style={{ fontWeight: "600" }}>
                                  {getOptionsLabel(el.id).length === 0 ? (
                                    "brak opcji dodatkowych"
                                  ) : (
                                    <ul
                                      style={{
                                        textTransform: "lowercase",
                                        margin: "0",
                                        paddingInlineStart: "20px",
                                      }}
                                    >
                                      {getOptionsLabel(el.id)
                                        .filter((op0) => op0 !== "")
                                        .map((op, index) => (
                                          <li key={index}>{op}</li>
                                        ))}
                                    </ul>
                                  )}
                                </span>
                              </p>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                padding: "5px 5px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0",
                                  textTransform: "uppercase",
                                  fontWeight: "600",
                                }}
                              >
                                Szacunkowa kalkulacja kosztu Twojej sprawy
                              </p>
                              <p
                                style={{
                                  margin: "0",
                                  textTransform: "lowercase",
                                  fontWeight: "300",
                                  color: "gray",
                                  fontSize: "2vw",
                                }}
                              >
                                przedstawiona kalkulacja opiera się na
                                szacunkowej wycenie korzyści z prowadzonej
                                sprawy{" "}
                                <span
                                  style={{
                                    textTransform: "uppercase",
                                    paddingLeft: "2px",
                                    paddingRight: "2px",
                                  }}
                                >
                                  {props.userCreditData.creditCurrency === "PLN"
                                    ? "CHF"
                                    : props.userCreditData.creditCurrency}
                                </span>{" "}
                                oraz deklarowanej przez kancelarie ofercie
                              </p>
                              <div style={{ padding: "10px 0px" }}>
                                <p
                                  style={{
                                    fontSize: "2vw",
                                    margin: "0",
                                    marginBottom: "5px",
                                  }}
                                >
                                  PODSTAWA WYLICZENIA WYNAGRODZENIA SUCCESS FEE:{" "}
                                  {getOfferCalc(el.id).floor}
                                </p>
                                <p
                                  style={{
                                    fontSize: "2vw",
                                    margin: "0",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "gray",
                                      textTransform: "lowercase",
                                    }}
                                  >
                                    ten element wynagrodzenia zapłacisz po
                                    podpisaniu umowy, zwykle kancelarie oferują
                                    14-dniowy termin płatności
                                  </span>
                                  <br />
                                  OPŁATA WSTĘPNA: {getOfferCalc(el.id).ow}
                                </p>
                                <p
                                  style={{
                                    fontSize: "2vw",
                                    margin: "0",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "gray",
                                      textTransform: "lowercase",
                                    }}
                                  >
                                    ten element wynagrodzenia zapłacisz po
                                    wygranej sprawie z części zwrotu
                                    napdpłaconych rat przez bank
                                  </span>
                                  <br />
                                  SUCCESS FEE: {getOfferCalc(el.id).sf}
                                  <br />
                                  WARTOŚĆ SUCCESS FEE: około{" "}
                                  {getOfferCalc(el.id).sf.includes("PLN")
                                    ? numberWithCommas(
                                        Math.round(getOfferCalc(el.id).sfMath)
                                      ) + " PLN"
                                    : numberWithCommas(
                                        Math.round(
                                          (getOfferCalc(el.id).sfMath / 100) *
                                            getOfferCalc(el.id).floorMath
                                        )
                                      ) + " PLN"}
                                </p>

                                <p
                                  style={{
                                    fontSize: "2vw",
                                    margin: "0",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "gray",
                                      textTransform: "lowercase",
                                    }}
                                  >
                                    łącznie całość szacowanego wynagrodzenia
                                    kancelarii za poprowadzenie Twojej sprawy{" "}
                                    <span
                                      style={{ textTransform: "uppercase" }}
                                    >
                                      {props.userCreditData.creditCurrency ===
                                      "PLN"
                                        ? "CHF"
                                        : props.userCreditData.creditCurrency}
                                    </span>
                                  </span>
                                  <br />
                                  <span style={{ fontWeight: "600" }}>
                                    SZACOWANA KWOTA WYNAGRODZENIA: około{" "}
                                    {getOfferCalc(el.id).sf.includes("PLN")
                                      ? numberWithCommas(
                                          Math.round(
                                            getOfferCalc(el.id).sfMath +
                                              getOfferCalc(el.id).owMath
                                          )
                                        ) + " PLN"
                                      : numberWithCommas(
                                          Math.round(
                                            (getOfferCalc(el.id).sfMath / 100) *
                                              getOfferCalc(el.id).floorMath +
                                              getOfferCalc(el.id).owMath
                                          )
                                        ) + " PLN"}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "block",
                          }}
                        >
                          <button
                            className="submitButtonFirstPage"
                            style={{
                              margin: "0",
                              fontSize: "3vw",
                              color: "white",
                              height: "3vh",
                              backgroundColor: "#949d97",
                              border: "0px solid #949d97",
                              borderRadius: "10px",
                              minWidth: "8vw",
                              padding: "5px 10px",
                              fontWeight: "900",
                              width: "100%",
                              marginTop: "10px",
                            }}
                            value={el.id}
                            onClick={(e) => {
                              setShowDetails(true);
                              setCompanyId(e.target.value);
                            }}
                          >
                            POKAż wizytówkę
                          </button>
                          {choosen
                            .split(",")
                            .filter((eq) => eq !== "")
                            .filter((ex) => +ex === +el.id).length === 0 &&
                          !sendAss ? (
                            <button
                              className="submitButtonFirstPage"
                              style={{
                                margin: "0",
                                fontSize: "3vw",
                                color: "white",
                                marginTop: "5px",
                                height: "3vh",
                                backgroundColor: "orange",
                                border: "0px solid #949d97",
                                borderRadius: "10px",
                                minWidth: "8vw",
                                padding: "0",
                                fontWeight: "900",
                                animation: "pulseNew 2s infinite",
                                width: "100%",
                                marginTop: "10px",
                              }}
                              value={el.id}
                              onClick={addChoosen}
                            >
                              Nawiąż kontakt
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="destkopView">{destkop}</div>
      <div className="mobileView">{mobile}</div>
    </>
  );
};

export default ThirdPage;
